module.exports = __webpack_public_path__ + "static/media/i7.197bf43d.jpg";